export default "__VITE_ASSET__Bp7suD4FlY0BAvMWIJaEGQ__"